import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetNoteTargets = (
    notetypeId: number | undefined,
    caseLocalCounselGuid: string | undefined,
    strategyTypeId: number | undefined,
    isQuadNoteEditor?: boolean | undefined
) => {
    const { zoneApiClient } = useZoneContext();

    return useQuery({
        queryKey: ['get-note-targets'],
        queryFn: async () => {
            const response = await zoneApiClient.getNoteTargets(
                notetypeId!,
                caseLocalCounselGuid,
                strategyTypeId
            );

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve note targets.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        enabled: !!notetypeId && !isQuadNoteEditor,
    });
};
